module.exports = __webpack_public_path__ + "img/inadequate.e5e0006b.svg";